import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';
import { Order } from '~hooks/useOrders/models';
import { makeOrderTitle } from '~utils/orders';

interface OrderCreatedToasterProps {
  isWaitingForJobs?: boolean;
  order: Order;
}

export default function OrderCreatedToaster({
  isWaitingForJobs,
  order,
}: OrderCreatedToasterProps) {
  return (
    <Box
      sx={{
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        minWidth: '290px',
      }}
    >
      <Typography sx={{ fontSize: '12px' }}>
        {t('dispatch.dispatch_v2.order_toast.order_created')}
      </Typography>

      <Typography>{makeOrderTitle(order, true)}</Typography>

      <SmallLoadingButton
        color="brandV2Green"
        loading={isWaitingForJobs}
        size="small"
        variant="contained"
      >
        {t('dispatch.dispatch_v2.order_toast.view_order')}
      </SmallLoadingButton>
    </Box>
  );
}
